<template>
<div class="auth-layout">
     <div class="nav hidden-lg-up">
          <router-link class="basix-home" :to="{path: '/'}"></router-link>
     </div>
     <div class="main row">
          <div class="auth-content col-md-6" id="container-login">
               <router-view></router-view>
          </div>
          <div class="auth-wallpaper col-md-6 hidden-md-down">
               <!-- <div class="oblique"></div> -->
               <div class="jumbotron">
                    <h1 class="display-4">Soft - RRHH</h1>
                    <p class="lead">This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.</p>
                    <hr class="my-4">
                    <p>It uses utility classes for typography and spacing to space content out within the larger container.</p>
                    <p class="lead">
                        <button type="submit" class="btn btn-default btn-md float-right">
                              <router-link class='link  float-right' :to="{name: 'Register'}">Create Account</router-link>
                         </button>
                    </p>
               </div>
               <router-link class="basix-home" :to="{path: '/'}">
                    <!-- <img src="../images/logo.png" alt="Logo">-->
               </router-link>
          </div>
     </div>
</div>
</template>

<script>
export default {
     name: 'AuthLayout'
}
</script>

<style lang="scss">
#container-login {
   background: #c3cdcf;

}
.jumbotron {
     background: none !important;
}

.jumbotron>* {
     color: #f4f4f4 !important;
}

.auth-layout {
     height: 100vH;
     margin: 0;

     .main {
          margin: 0;
          height: 100%;

          .auth-content {
               padding: 0;
               display: flex;
               align-items: center;
               justify-content: center;
               background-color: white;
          }

          .auth-wallpaper {
               background-color: #333;
               overflow: hidden;
               display: flex;
               align-items: center;
               justify-content: center;

               .basix-home {
                    z-index: 2;
                    font-size: 2.625rem;
                    color: #1ec260;
               }

               .oblique {
                    position: absolute;
                    background-color: #282828;
                    left: calc(50% - 23%/2);
                    transform: rotate(150deg);
                    width: 27%;
                    height: 115%;
               }
          }
     }

}
</style>
